import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { addChargingConnector } from '../../api/charging-connector.ts';
import { AddChargingConnectorRequest } from '../../api/requests/charging-connector-request.ts';

export default function useAddChargingConnector(): UseMutationResult<
  Awaited<ReturnType<typeof addChargingConnector>>,
  Error,
  AddChargingConnectorRequest
> {
  return useMutation({
    mutationFn: addChargingConnector,
  });
}
